





























import Vue, { PropType } from 'vue';
import MStoreDocumentInformationTab from '@/components/shared/Tabs/MStoreDocumentInformationTab.vue';
import MStoreNarrativeTab from './Tabs/MStoreNarrativeTab.vue';
import MStoreRetentionTab from './Tabs/MStoreRetentionTab.vue';
import MStoreRelatedDocumentsTab from './Tabs/MStoreRelatedDocumentsTab.vue';
import { DocumentTabModel } from '@/services/GeneratedApi';
import MStoreVersionsTab from './Tabs/MStoreVersionsTab.vue';
import MStoreDocumentHistoryTab from './Tabs/MStoreDocumentHistoryTab.vue';
import MStoreWorkflowInformationTab from './Tabs/MStoreWorkflowInformationTab.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'HorizontalDocumentTabs',
  props: {
    documentId: {
      type: Number,
      required: true
    },
    cabinetId: {
      type: String,
      required: true
    },
    hideTabs: {
      type: Boolean,
      required: true
    },
    documentTabs: {
      type: Array as PropType<DocumentTabModel[]>,
      required: true
    }
  },
  data() {
    return { tabIndex: 0, isTabExpanded: false, isLoading: true };
  },
  computed: {},
  methods: {
    openTab(tab: number) {
      this.isTabExpanded = !(tab === this.tabIndex && this.isTabExpanded);
      this.tabIndex = tab;
    },
    tabClass(tab: number) {
      return tab === this.tabIndex && this.isTabExpanded ? 'tab-button active-tab-button' : 'tab-button inactive-tab-button';
    }
  },
  components: {
    MStoreDocumentInformationTab,
    MStoreNarrativeTab,
    MStoreRetentionTab,
    MStoreRelatedDocumentsTab,
    MStoreVersionsTab,
    MStoreDocumentHistoryTab,
    MStoreWorkflowInformationTab,
    LoadingSpinner
  }
});
